module.exports = __webpack_public_path__ + "static/media/Tuan-Anh Bach Resume September.16423b12.pdf";